import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Search, User } from "lucide-react";

const ROLE_CLS = {
  super_admin: "bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900",
  createur: "bg-orange-100 text-orange-700 dark:bg-orange-500/20 dark:text-orange-300",
  admin: "bg-blue-100 text-blue-700 dark:bg-blue-500/20 dark:text-blue-300",
  staff: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300",
};

export default function SuperAdminUsers() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const [role, setRole] = useState("");
  useEffect(() => { api.get(`/superadmin/users${role ? `?role=${role}` : ""}`).then((r) => setUsers(r.data)); }, [role]);

  const filtered = users.filter((u) => !q || [u.email, u.full_name, u.company_name].filter(Boolean).some((v) => v.toLowerCase().includes(q.toLowerCase())));

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold">Utilisateurs</h1>
        <p className="text-sm text-slate-500">Tous les utilisateurs de la plateforme, tous rôles confondus</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {["", "super_admin", "createur", "admin", "staff"].map((r) => (
          <button key={r || "all"} onClick={() => setRole(r)}
            data-testid={`sa-users-tab-${r || "all"}`}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold ${role === r ? "bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900" : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300"}`}>
            {r ? r : "Tous"}
          </button>
        ))}
        <div className="relative flex-1 min-w-[200px]">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input placeholder="Rechercher…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" data-testid="sa-users-search" />
        </div>
      </div>

      <Card>
        <CardContent className="p-0 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase text-slate-500 border-b border-slate-200 dark:border-slate-800">
              <tr><th className="text-left p-3">Nom</th><th className="text-left">Email</th><th className="text-left">Rôle</th><th className="text-left">Entreprise</th><th className="text-left">Statut</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
              {filtered.map((u) => (
                <tr key={u.id} data-testid={`sa-user-${u.email}`}>
                  <td className="p-3 flex items-center gap-2"><div className="w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-800 grid place-items-center"><User className="w-4 h-4" /></div>{u.full_name}</td>
                  <td className="text-xs">{u.email}</td>
                  <td><span className={`text-xs px-2 py-0.5 rounded-full font-semibold capitalize ${ROLE_CLS[u.role] || "bg-slate-100"}`}>{u.role}</span></td>
                  <td className="text-xs">{u.company_name || "—"}</td>
                  <td>{u.active === false ? <span className="text-xs text-slate-500">Désactivé</span> : <span className="text-xs text-emerald-600">Actif</span>}</td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-slate-500">Aucun utilisateur</td></tr>}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
